module.exports = __webpack_public_path__ + "img/3A.cbc95c54.png";